// Hostname-aware base path for the Attendance app.
// On the dedicated attendance domain (REACT_APP_ATTENDANCE_HOSTS, e.g. app.msrpro.in) routes live at "/" and "/app/*";
// on the marketing domain they stay under "/attendance".
const HOSTS = (process.env.REACT_APP_ATTENDANCE_HOSTS || "app.msrpro.in").split(",").map((h) => h.trim().toLowerCase()).filter(Boolean);
const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

export const IS_ATT_HOST = HOSTS.includes(host);
export const ATT_BASE = IS_ATT_HOST ? "" : "/attendance";
export const attPath = (p = "") => `${ATT_BASE}${p}` || "/";
export const ATT_PRIMARY_URL = `https://${HOSTS[0]}`;

// Redirect mode for old URLs (masharaskills.com/attendance/*): "off" | "test" | "on"
export const ATT_REDIRECT_MODE = (process.env.REACT_APP_ATTENDANCE_REDIRECT || "off").toLowerCase();

export function attRedirectTarget(pathname, search, hash) {
  if (IS_ATT_HOST || !pathname.startsWith("/attendance")) return null;
  if (ATT_REDIRECT_MODE === "off") return null;
  if (ATT_REDIRECT_MODE === "test") {
    const params = new URLSearchParams(search);
    if (params.get("att_redirect") === "1") localStorage.setItem("att_redirect_test", "1");
    if (localStorage.getItem("att_redirect_test") !== "1") return null;
  }
  const rest = pathname.slice("/attendance".length) || "/";
  return `${ATT_PRIMARY_URL}${rest}${search}${hash}`;
}
